angular.module('unica_event_field.event_field_controllers')

.controller('EventFieldListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, EventFieldCreateService,
	EventFieldListService, EventFieldDeleteService
) {

	$scope.eventFieldList = [];

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadEventFieldLists = function()
	{
		$scope.showLoader();

		EventFieldListService
			.list( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.eventFieldList = $scope.eventFieldList.concat( data );
				}
			});
	};

	$scope.loadEventFieldLists();

	$scope.cloneEventField = function(eventFieldId)
	{
		$confirm({
			title: 'Sei sicuro di voler duplicare questo campo?',
			text: 'Confermi la duplicazione del campo?'
		}).then(function() {

			$scope.showLoader();

			EventFieldCreateService
				.clone( eventFieldId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.showSuccessMsg('Campo duplicato con successo!', '');
						$scope.eventFieldList = [];
						$scope.loadEventFieldLists();
					}
				});

		}, function() {
			// Cancel
		});
	};

	$scope.deleteEventField = function(eventFieldId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare questo campo?',
			text: 'Confermi la cancellazione del campo?'
		}).then(function() {

			$scope.showLoader();

			EventFieldDeleteService
				.delete( eventFieldId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.eventFieldList, function(eventField, key) {
							if ( eventField.id === eventFieldId ) {
								$scope.eventFieldList.splice(key, 1);
							}
						});

						$scope.showSuccessMsg('Campo eliminato con successo!', '');
					}
				});

		}, function() {
			// Cancel
		});
	};

});